export interface ClientConfig {
    brandColor: string; // Hex code, e.g., "#3B82F6"
    logo?: string; // URL or path to logo image. If undefined, uses default Shield icon.
    companyName: string;
}

export const defaultConfig: ClientConfig = {
    // Defaulting to the current blue-ish theme color roughly 
    // tailored to match the 'primary' or 'blue-500' look.
    // Tailwind blue-600 is #2563EB, blue-500 is #3B82F6.
    // The current primary in index.css is 222.2 47.4% 11.2% (very dark blue)
    // but the UI uses blue-500/400 explicitly in many places.
    // Let's set a vibrant blue as the default brand color.
    brandColor: "#3B82F6", 
    companyName: "TalentSync",
    // logo: undefined, // undefined means use default icon
};
